<template>
  <div class="case-list-view">
    <section class="toolbar-card">
      <div>
        <h2>案例列表 Case List</h2>
        <p>维护项目案例、国家、封面图、头图和图库。</p>
      </div>
      <div class="toolbar-card__actions">
        <el-input
          v-model.trim="keyword"
          clearable
          placeholder="搜索标题/国家 Search"
          size="small"
          @keyup.enter.native="handleFilterChange"
          @clear="handleFilterChange"
        />
        <el-select v-model="statusFilter" clearable placeholder="状态 Status" size="small" @change="handleFilterChange">
          <el-option label="草稿 Draft" value="draft" />
          <el-option label="启用 Active" value="active" />
        </el-select>
        <el-button size="small" @click="handleFilterChange">查询 Search</el-button>
        <el-button type="primary" size="small" @click="openCreateDialog">新增案例 Add Case</el-button>
      </div>
    </section>

    <section class="table-card">
      <el-table :data="cases" v-loading="loading" stripe>
        <el-table-column label="封面 Cover" min-width="110">
          <template slot-scope="{ row }">
            <el-image v-if="row.coverImage || row.heroImage" class="table-thumb" :src="assetUrl(row.coverImage || row.heroImage)" :preview-src-list="[assetUrl(row.coverImage || row.heroImage)]" :alt="row.title" fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题 Title" min-width="180" />
        <el-table-column prop="slug" label="标识 Slug" min-width="180" />
        <el-table-column prop="country" label="国家 Country" min-width="140" />
        <el-table-column label="图库 Gallery" min-width="110">
          <template slot-scope="{ row }">
            {{ Array.isArray(row.gallery) ? row.gallery.length : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="排序 Sort" min-width="140">
          <template slot-scope="{ row }">
            <el-input-number
              class="sort-input"
              :value="row.sortOrder"
              :min="0"
              :step="1"
              size="mini"
              @change="value => updateCaseSortOrder(row, value)"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态 Status" min-width="150">
          <template slot-scope="{ row }">
            <el-switch
              :value="row.status === 'active'"
              active-text="启用 Active"
              inactive-text="草稿 Draft"
              @change="value => toggleCaseStatus(row, value)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作 Actions" min-width="190" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="previewCase(row)">预览 Preview</el-button>
            <el-button type="text" @click="openEditDialog(row)">编辑 Edit</el-button>
            <el-button type="text" class="danger-btn" @click="handleDelete(row)">删除 Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </section>

    <el-dialog :title="dialogMode === 'create' ? '新增案例 Add Case' : '编辑案例 Edit Case'" :visible.sync="dialogVisible" width="860px" @closed="resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <div class="form-grid">
          <el-form-item label="标题 Title" prop="title">
            <el-input v-model.trim="form.title" />
          </el-form-item>
          <el-form-item label="标识 Slug" prop="slug">
            <el-input v-model.trim="form.slug" @input="handleSlugInput" />
          </el-form-item>
        </div>

        <div class="form-grid">
          <el-form-item label="国家 Country">
            <el-input v-model.trim="form.country" />
          </el-form-item>
          <el-form-item label="状态 Status" prop="status">
            <el-select v-model="form.status" placeholder="请选择 Please select">
              <el-option label="草稿 Draft" value="draft" />
              <el-option label="启用 Active" value="active" />
            </el-select>
          </el-form-item>
        </div>

        <div class="form-grid">
          <el-form-item label="封面图 Cover Image">
            <div class="image-field">
              <el-input v-model.trim="form.coverImage" placeholder="图片地址 Image URL" />
              <el-upload action="" :http-request="request => uploadImage('coverImage', request)" :show-file-list="false" accept="image/*">
                <el-button size="small" :loading="uploadingTarget === 'coverImage'">上传 Upload</el-button>
              </el-upload>
              <el-button size="small" @click="openMediaPicker('coverImage')">选择 Choose</el-button>
            </div>
            <el-image v-if="form.coverImage" class="image-preview" :src="assetUrl(form.coverImage)" :preview-src-list="[assetUrl(form.coverImage)]" fit="cover" />
          </el-form-item>
          <el-form-item label="头图 Hero Image">
            <div class="image-field">
              <el-input v-model.trim="form.heroImage" placeholder="图片地址 Image URL" />
              <el-upload action="" :http-request="request => uploadImage('heroImage', request)" :show-file-list="false" accept="image/*">
                <el-button size="small" :loading="uploadingTarget === 'heroImage'">上传 Upload</el-button>
              </el-upload>
              <el-button size="small" @click="openMediaPicker('heroImage')">选择 Choose</el-button>
            </div>
            <el-image v-if="form.heroImage" class="image-preview" :src="assetUrl(form.heroImage)" :preview-src-list="[assetUrl(form.heroImage)]" fit="cover" />
          </el-form-item>
        </div>

        <div class="form-grid">
          <el-form-item label="排序 Sort Order">
            <el-input-number v-model="form.sortOrder" :min="0" :step="1" />
          </el-form-item>
        </div>

        <el-form-item label="简介 Intro">
          <el-input v-model.trim="form.intro" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="正文 Body">
          <el-input v-model.trim="form.body" type="textarea" :rows="5" />
        </el-form-item>

        <el-form-item label="图库 Gallery">
          <div class="image-group-list">
            <div v-for="(item, index) in form.gallery" :key="index" class="image-group-item">
              <el-input v-model.trim="item.imageUrl" placeholder="图片地址 Image URL" />
              <el-input-number v-model="item.sortOrder" :min="0" :step="1" size="small" />
              <el-upload action="" :http-request="request => uploadImage(index, request)" :show-file-list="false" accept="image/*">
                <el-button size="small" :loading="uploadingTarget === index">上传 Upload</el-button>
              </el-upload>
              <el-button size="small" @click="openMediaPicker(index)">选择 Choose</el-button>
              <div class="order-actions">
                <el-button size="mini" :disabled="index === 0" @click="moveGalleryItem(index, -1)">上移 Up</el-button>
                <el-button size="mini" :disabled="index === form.gallery.length - 1" @click="moveGalleryItem(index, 1)">下移 Down</el-button>
              </div>
              <el-button size="small" class="danger-btn" @click="removeGalleryItem(index)">删除 Delete</el-button>
              <el-image v-if="item.imageUrl" class="group-preview" :src="assetUrl(item.imageUrl)" :preview-src-list="[assetUrl(item.imageUrl)]" fit="cover" />
            </div>
          </div>
          <el-button size="small" @click="addGalleryItem">添加图片 Add Image</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible = false">取消 Cancel</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">保存 Save</el-button>
      </span>
    </el-dialog>

    <media-picker-dialog
      :visible.sync="mediaPickerVisible"
      upload-module="case"
      @select="chooseMedia"
    />
  </div>
</template>

<script>
import { createCase, deleteCase, fetchCases, updateCase } from '../../api/cases'
import { resolveAssetUrl, uploadMediaAsset } from '../../api/media'
import MediaPickerDialog from '../../components/MediaPickerDialog.vue'
import { casePreviewUrl, openPreviewUrl } from '../../utils/preview'
import { toSlug } from '../../utils/slug'

const createEmptyForm = () => ({
  id: null,
  title: '',
  slug: '',
  country: '',
  coverImage: '',
  heroImage: '',
  intro: '',
  body: '',
  status: 'active',
  sortOrder: 0,
  gallery: []
})

export default {
  name: 'CaseListView',
  components: {
    MediaPickerDialog
  },
  data () {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      mediaPickerVisible: false,
      dialogMode: 'create',
      slugTouched: false,
      uploadingTarget: '',
      pickerTarget: '',
      keyword: '',
      statusFilter: '',
      cases: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: createEmptyForm(),
      rules: {
        title: [{ required: true, message: '请输入标题 Please input title.', trigger: 'blur' }],
        slug: [{ required: true, message: '请输入标识 Please input slug.', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态 Please select status.', trigger: 'change' }]
      }
    }
  },
  watch: {
    'form.title' (value) {
      if (!this.slugTouched) {
        this.form.slug = toSlug(value)
      }
    }
  },
  async created () {
    await this.loadData()
  },
  methods: {
    assetUrl: resolveAssetUrl,
    caseQueryParams () {
      return {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        keyword: this.keyword || undefined,
        status: this.statusFilter || undefined
      }
    },
    async loadData () {
      this.loading = true
      try {
        const { data } = await fetchCases(this.caseQueryParams())
        this.cases = Array.isArray(data) ? data : data.items
        this.pagination.total = Array.isArray(data) ? data.length : data.total
      } catch (error) {
        this.$message.error('案例数据加载失败 Failed to load cases.')
      } finally {
        this.loading = false
      }
    },
    handleFilterChange () {
      this.pagination.page = 1
      this.loadData()
    },
    handlePageChange (page) {
      this.pagination.page = page
      this.loadData()
    },
    handlePageSizeChange (pageSize) {
      this.pagination.page = 1
      this.pagination.pageSize = pageSize
      this.loadData()
    },
    openCreateDialog () {
      this.dialogMode = 'create'
      this.slugTouched = false
      this.dialogVisible = true
    },
    openEditDialog (row) {
      this.dialogMode = 'edit'
      this.slugTouched = true
      this.form = {
        id: row.id,
        title: row.title || '',
        slug: row.slug || '',
        country: row.country || '',
        coverImage: row.coverImage || '',
        heroImage: row.heroImage || '',
        intro: row.intro || '',
        body: row.body || '',
        status: row.status || 'draft',
        sortOrder: row.sortOrder || 0,
        gallery: Array.isArray(row.gallery)
          ? row.gallery.map(item => ({
            imageUrl: item.imageUrl || '',
            sortOrder: item.sortOrder || 0
          }))
          : []
      }
      this.dialogVisible = true
    },
    resetForm () {
      this.form = createEmptyForm()
      this.slugTouched = false
      if (this.$refs.form) this.$refs.form.resetFields()
    },
    handleSlugInput () {
      this.slugTouched = true
      this.form.slug = toSlug(this.form.slug)
    },
    addGalleryItem () {
      this.form.gallery.push({ imageUrl: '', sortOrder: this.form.gallery.length })
    },
    removeGalleryItem (index) {
      this.form.gallery.splice(index, 1)
      this.normalizeGallerySortOrder()
    },
    moveGalleryItem (index, direction) {
      const targetIndex = index + direction
      if (targetIndex < 0 || targetIndex >= this.form.gallery.length) return

      const nextGallery = this.form.gallery.slice()
      const current = nextGallery[index]
      nextGallery.splice(index, 1)
      nextGallery.splice(targetIndex, 0, current)
      this.form.gallery = nextGallery
      this.normalizeGallerySortOrder()
    },
    normalizeGallerySortOrder () {
      this.form.gallery = this.form.gallery.map((item, index) => ({
        ...item,
        sortOrder: index
      }))
    },
    openMediaPicker (target) {
      this.pickerTarget = target
      this.mediaPickerVisible = true
    },
    chooseMedia (item) {
      if (typeof this.pickerTarget === 'number') {
        this.form.gallery[this.pickerTarget].imageUrl = item.fileUrl
      } else {
        this.form[this.pickerTarget] = item.fileUrl
      }
      this.mediaPickerVisible = false
    },
    previewCase (row) {
      openPreviewUrl(casePreviewUrl(row))
    },
    async uploadImage (target, { file }) {
      if (this.uploadingTarget !== '') return
      this.uploadingTarget = target
      try {
        const { data } = await uploadMediaAsset(file, 'case')
        if (typeof target === 'number') {
          this.form.gallery[target].imageUrl = data.fileUrl
        } else {
          this.form[target] = data.fileUrl
        }
        this.$message.success('图片已上传 Image uploaded.')
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || '上传失败 Upload failed.')
      } finally {
        this.uploadingTarget = ''
      }
    },
    handleSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid || this.submitting) return
        this.submitting = true
        try {
          const payload = {
            ...this.form,
            gallery: this.form.gallery
              .filter(item => item.imageUrl)
              .map((item, index) => ({
                ...item,
                sortOrder: index
              }))
          }
          if (this.dialogMode === 'create') {
            await createCase(payload)
            this.$message.success('案例已创建 Case created.')
          } else {
            await updateCase(this.form.id, payload)
            this.$message.success('案例已更新 Case updated.')
          }
          this.dialogVisible = false
          await this.loadData()
        } catch (error) {
          this.$message.error((error.response && error.response.data && error.response.data.message) || '保存失败 Save failed.')
        } finally {
          this.submitting = false
        }
      })
    },
    buildCasePayload (row, overrides = {}) {
      return {
        title: row.title,
        slug: row.slug,
        country: row.country || '',
        coverImage: row.coverImage || '',
        heroImage: row.heroImage || '',
        intro: row.intro || '',
        body: row.body || '',
        status: row.status || 'draft',
        sortOrder: row.sortOrder || 0,
        gallery: Array.isArray(row.gallery)
          ? row.gallery
            .filter(item => item.imageUrl)
            .map((item, index) => ({
              imageUrl: item.imageUrl,
              sortOrder: index
            }))
          : [],
        ...overrides
      }
    },
    async toggleCaseStatus (row, enabled) {
      const previousStatus = row.status
      const nextStatus = enabled ? 'active' : 'draft'
      row.status = nextStatus

      try {
        await updateCase(row.id, this.buildCasePayload(row, { status: nextStatus }))
        this.$message.success('状态已更新 Status updated.')
      } catch (error) {
        row.status = previousStatus
        this.$message.error((error.response && error.response.data && error.response.data.message) || '状态更新失败 Failed to update status.')
      }
    },
    async updateCaseSortOrder (row, value) {
      const previousSortOrder = row.sortOrder || 0
      const nextSortOrder = Number(value || 0)
      row.sortOrder = nextSortOrder

      try {
        await updateCase(row.id, this.buildCasePayload(row, { sortOrder: nextSortOrder }))
        this.$message.success('排序已更新 Sort order updated.')
      } catch (error) {
        row.sortOrder = previousSortOrder
        this.$message.error((error.response && error.response.data && error.response.data.message) || '排序更新失败 Failed to update sort order.')
      }
    },
    handleDelete (row) {
      this.$confirm(`确认删除案例“${row.title}”吗？\nConfirm deleting this case?`, '删除确认 Delete Confirmation', {
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCase(row.id)
          this.$message.success('案例已删除 Case deleted.')
          await this.loadData()
        } catch (error) {
          this.$message.error((error.response && error.response.data && error.response.data.message) || '删除失败 Delete failed.')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar-card,
.table-card {
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--panel);
  box-shadow: 0 16px 32px rgba(23, 20, 17, 0.04);
}

.toolbar-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px;
}

.toolbar-card h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
}

.toolbar-card p {
  margin: 8px 0 0;
  color: var(--muted);
}

.toolbar-card__actions,
.image-field,
.picker-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toolbar-card__actions {
  flex-shrink: 0;
}

.toolbar-card__actions .el-input,
.toolbar-card__actions .el-select {
  width: 190px;
}

.table-card {
  margin-top: 18px;
  padding: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 4px 2px;
}

.table-thumb {
  display: block;
  width: 72px;
  height: 54px;
  object-fit: cover;
  border-radius: 6px;
  background: #f2eee8;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.sort-input {
  width: 112px;
}

.image-field .el-input {
  flex: 1;
}

.image-preview {
  display: block;
  width: 220px;
  max-width: 100%;
  aspect-ratio: 4 / 3;
  margin-top: 10px;
  object-fit: cover;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f2eee8;
}

.image-group-list {
  display: grid;
  gap: 12px;
  margin-bottom: 10px;
}

.image-group-item {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 120px auto auto auto auto 84px;
  gap: 8px;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.55);
}

.group-preview {
  width: 84px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  background: #f2eee8;
}

.order-actions {
  display: inline-flex;
  gap: 6px;
}

.picker-toolbar {
  margin-bottom: 16px;
}

.picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  min-height: 260px;
}

.picker-card {
  overflow: hidden;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--panel);
  text-align: left;
  cursor: pointer;
}

.picker-card .el-image {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.picker-card span {
  display: block;
  overflow: hidden;
  padding: 8px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.danger-btn {
  color: #d14343;
}

@media (max-width: 960px) {
  .toolbar-card,
  .form-grid,
  .image-group-item {
    grid-template-columns: 1fr;
  }

  .toolbar-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .toolbar-card__actions,
  .image-field {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
